<div>
  <h2 style="font-weight: 600 !important;position: absolute; top: 5; z-index: 1; font-family: 'Poppins';">{{heading}}</h2>
  <div id='heatMapDiv' #heatMapDiv>
  </div>
</div>
